import { Mapper } from 'src/base/mapper'
import { ProvinceTypeEntity } from 'src/data/entities/common.entity'
import { ProvinceTypeModel } from 'src/domain/models/common.model'

export class ProvinceMapper extends Mapper<ProvinceTypeEntity, ProvinceTypeModel> {
	mapFrom(param: ProvinceTypeEntity): ProvinceTypeModel {
		return this.resultData(param)
	}

	mapTo(param: ProvinceTypeModel): ProvinceTypeEntity {
		return this.resultData(param)
	}

	resultData(param: ProvinceTypeEntity | ProvinceTypeModel) {
		return {
			provinceCode: param.provinceCode,
			provinceName: param.provinceName,
		}
	}
}
